import styled from '@emotion/styled';

export const Container = styled.div({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  justifyContent: 'left',
  margin: '4px',
  width: 'auto',
});

export const Label = styled.label({
  fontFamily: 'Rubik',
  fontSize: '16px',
  lineHeight: '24px',
  padding: '0 8px',
  pointerEvents: 'none',
});

export const Select = styled.select({
  borderRadius: '8px',
  fontFamily: 'Rubik',
  fontSize: '16px',
  fontWeight: '400',
  gap: '8px',
  height: '48px',
  lineHeight: '24px',
  padding: '12px 16px',
  width: '100%',
});

export const Option = styled.option({
  fontWeight: '400',
  fontSize: '16px',
  height: '24px',
  lineHeight: '24px',
  fontFamily: 'Rubik',
});
